module.exports = __webpack_public_path__ + "static/img/btn_task_yes.b6ac4b53.svg";